const publishDestinationEditorTabs = {
  SETTINGS: 'settings',
  DESIGN:   'design',
  PRIVACY:  'privacy',
  INSTALL:  'install',
};
publishDestinationEditorTabs.ALL = _.values(publishDestinationEditorTabs);

export default publishDestinationEditorTabs;
